import { Component, Input } from '@angular/core';
import { IoniconsOutline, PermissionDialog } from '@pt/pt-models';
import { PermissionsDialogService } from '../../services/permissions-dialog.service';

@Component({
  selector: 'pt-permission-icon-button',
  template: `
    <div class="d-inline cursor-pointer"
         (click)="open()"
         *ngIf='permissionDialog'
         ngbTooltip="{{'TOOLTIP.PERMISSIONS' | translate}}">
      <pt-icon class="cursor-pointer" [ngStyle]="{'color': color}" [key]='IconPermission'></pt-icon>
      <span *ngIf="label" class="cursor-pointer" [ngStyle]="{'color': color}">{{ label }}</span>
    </div>
  `
})
export class PermissionIconButtonComponent {
  @Input() permissionDialog: PermissionDialog;
  @Input() color = 'white';
  @Input() label?: string;

  IconPermission = IoniconsOutline.key;

  constructor(
    private permissionDialogService: PermissionsDialogService,
  ) {
  }


  open(): void {
    if (this.permissionDialog) {
      this.permissionDialogService.runPermissionDialog(this.permissionDialog);
    }
  }

}
